export const CINEMA_ADVERTISING_REQUEST = 'advertising/CINEMA_ADVERTISING_REQUEST';
export const CINEMA_ADVERTISING_SUCCESS = 'advertising/CINEMA_ADVERTISING_SUCCESS';

export const ONLINE_ADVERTISING_REQUEST = 'advertising/ONLINE_ADVERTISING_REQUEST';
export const ONLINE_ADVERTISING_SUCCESS = 'advertising/ONLINE_ADVERTISING_SUCCESS';

export const PRESS_INFO_REQUEST = 'advertising/PRESS_INFO_REQUEST';
export const PRESS_INFO_SUCCESS = 'advertising/PRESS_INFO_SUCCESS';
